import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import axiosInstance from "../../utils/axiosInstance";
import Cookies from 'js-cookie';
const initialStateAccount = {
    Account: [],
    // currUser: null,
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getAccount = createAsyncThunk(
    'account/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllAccount', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log(response.data.accounts);
            return response.data.accounts;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const createAccount = createAsyncThunk(
    'account/add',
    async (data, { dispatch, rejectWithValue }) => {
        console.log(data.submissionValues);
        try {
            const response = await axiosInstance.post(BASE_URL + '/createAccount', data.submissionValues, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log(response.data.account);
            dispatch(getAccount());
            return response.data.account;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteAccount = createAsyncThunk(
    'account/delete',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id);
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteAccount/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // dispatch(getDealers());
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getAccountById = createAsyncThunk(
    'account/view',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getAccountById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.account;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const updateAccount = createAsyncThunk(
    'account/edit',
    async ({ id, submissionValues }, { dispatch, rejectWithValue }) => {
        console.log("formdata", submissionValues);
        try {
            const response = await axiosInstance.put(`${BASE_URL}/updateAccount/${id}`, submissionValues, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log("Update ID :", response.data)
            dispatch(getAccount());
            return response.data.account;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getAllMarketingData = createAsyncThunk(
    'account/marketing',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllMarketingData', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.market;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const AccountSlice = createSlice({
    name: 'account',
    initialState: initialStateAccount,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAccount.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Account...';
            })
            .addCase(getAccount.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Account fetched successfully';
                state.Account = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getAccount.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Accounts';
            })
            .addCase(createAccount.pending, (state) => {
                state.loading = true;
                state.message = 'Adding dealer...';
            })
            .addCase(createAccount.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Account.push(action.payload);
                state.message = action.payload?.message || 'Account added successfully';
            })
            .addCase(createAccount.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add Account';
            })
            .addCase(deleteAccount.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting Account...';
            })
            .addCase(deleteAccount.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.users = state.Account.filter((user) => user._id !== action.payload);
                state.message = action.payload?.message || 'Account deleted successfully';
            })
            .addCase(deleteAccount.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete Acoount';
            })
            .addCase(updateAccount.pending, (state) => {
                state.loading = true;
                state.message = 'Editing Account...';
            })
            .addCase(updateAccount.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (Array.isArray(state.Account)) {
                    state.Account = state.Account.map(account =>
                        account._id === action.payload?._id ? action.payload : account
                    );
                }
                state.message = 'Account updated successfully';
            })
            .addCase(updateAccount.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Account';
            })
            .addCase(getAllMarketingData.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Marketing Data...';
            })
            .addCase(getAllMarketingData.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Marketing Data fetched successfully';
                state.market = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getAllMarketingData.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Marketing Data';
            })
    }
});


export default AccountSlice.reducer;